import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { popularTags } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-primary-950 text-background-100">
      <div className="container-editorial grid grid-cols-1 gap-10 py-14 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-flashlight-fill text-lg" />
            </span>
            <span className="font-heading text-xl font-black tracking-tight text-background-50">热点内幕</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-100/60">
            聚焦热点事件的独家爆料与知情人透露，把分散的一手信息整理成可读的线索，让你在信息洪流里快一步。
          </p>
          <div className="mt-5 flex items-center gap-2">
            {["ri-wechat-line", "ri-weibo-line", "ri-mail-line"].map((icon) => (
              <span
                key={icon}
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-100/80 transition-colors hover:bg-primary-600 hover:text-background-50"
              >
                <i className={`${icon} text-lg`} />
              </span>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-wide text-background-50">内容栏目</h4>
          <ul className="mt-4 space-y-2.5">
            {categories.map((cat) => (
              <li key={cat.slug}>
                <Link
                  to={`/rumors?cat=${cat.slug}`}
                  className="text-sm text-background-100/60 transition-colors hover:text-accent-300"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-wide text-background-50">热门标签</h4>
          <div className="mt-4 flex flex-wrap gap-2">
            {popularTags.map((tag) => (
              <span
                key={tag}
                className="rounded-full border border-background-50/15 px-3 py-1 text-xs text-background-100/70"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-wide text-background-50">关于与联系</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-background-100/60">
            <li>
              <Link to="/about" className="transition-colors hover:text-accent-300">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/rumors" className="transition-colors hover:text-accent-300">
                全部爆料
              </Link>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-base" />
              tips@redian-neimu.example.com
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-information-line mt-0.5 text-base" />
              <span className="text-xs leading-relaxed text-background-100/50">
                站内内容为线索整理与公开信息梳理，涉及主体均以化名或泛指描述。
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="container-editorial flex flex-col gap-3 py-5 text-xs text-background-100/45 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 热点内幕 · 保留所有权利</p>
          <p>一手信息 · 持续更新 · 理性阅读</p>
        </div>
      </div>
    </footer>
  );
}